import {Tutorial} from "myfitworld-model";

export const getVideoSourceByAppSection = (tutorials: Tutorial[], appSection: string, userLanguage: string | undefined): string | undefined => {
  const tutorial = tutorials.find((tutorial) => tutorial?.appSection === appSection);

  return userLanguage === 'sr' ? tutorial?.videoLinkSR : tutorial?.videoLink;
};
